<template>
    <div>
        <span>Dados Gerais</span>
        <b-row class="m-2">
            <b-col cols="12" md="6" lg="4" class="text-left mb-2">
                <span><b>N°/Ano da {{licitacao.IdModalidade !== 38 ? 'Licitação' : 'Dispensa'}}</b></span>
                <br />
                <span class="pos-left">{{ licitacao.NumeroAnoLicitacao }}</span>
            </b-col>
            <b-col cols="12" md="6" lg="4" class="text-left mb-2">
                <span><b>Natureza do Objeto</b></span>
                <br />
                <span class="pos-left">{{ licitacao.DeObjetoLicitacao }}</span>
            </b-col>
            <b-col cols="12" md="6" lg="4" class="text-left mb-2">
                <span><b>Natureza da Obra</b></span>
                <br />
                <span class="pos-left">{{
                    licitacao.IdNaturezaObraNavigation ? licitacao.IdNaturezaObraNavigation.DeNaturezaObra : '-' }}</span>
            </b-col>
            <b-col cols="12" md="6" lg="4" class="text-left mb-2">
                <span><b>Modalidade</b></span>
                <br />
                <span class="pos-left">{{ licitacao.IdModalidadeNavigation ? licitacao.IdModalidadeNavigation.DeModalidade :
                    '-'
                }}</span>
            </b-col>
            <b-col cols="12" md="6" lg="4" class="text-left mb-2">
                <span><b>Critério de Julgamento</b></span>
                <br />
                <span class="pos-left">{{
                    licitacao.IdCritJulgamentoNavigation ? licitacao.IdCritJulgamentoNavigation.DeCriterioJulgamento : '-'
                }}</span>
            </b-col>
            <b-col cols="12" md="6" lg="4" class="text-left mb-2">
                <span><b>Nº do Processo Administrativo</b></span>
                <br />
                <span class="pos-left">{{ licitacao.DeNrProcessoAdmin }}</span>
            </b-col>
            <b-col cols="12" md="6" lg="4" class="text-left mb-2">
                <span><b>Valor Estimado</b></span>
                <br />
                <span class="pos-left">{{ formatMoeda(licitacao.VlEstimadoLicitacao) }}</span>
            </b-col>
            <b-col cols="12" md="6" lg="4" class="text-left mb-2">
                <span><b>Valor Licitado</b></span>
                <br />
                <span class="pos-left">{{ formatMoeda(licitacao.VlLicitacao) }}</span>
            </b-col>
            <b-col cols="12" md="6" lg="4" class="text-left mb-2">
                <span><b>Data de Homologação</b></span>
                <br />
                <span class="pos-left">{{ licitacao.DtHomologacao ? licitacao.DtHomologacao.toLocaleDateString() : ''
                }}</span>
            </b-col>
            <b-col cols="12" md="6" lg="4" class="text-left mb-2">
                <span><b>Data de Ratificação</b></span>
                <br />
                <span class="pos-left">{{ licitacao.DtHomologacao ? formatData(licitacao.DtHomologacao) : '-' }}</span>
            </b-col>
            <b-col cols="12" md="6" lg="4" class="text-left mb-2">
                <span><b>Objeto</b></span>
                <br />
                <span class="pos-left">{{ licitacao.DeObjetoLicitacao }}</span>
            </b-col>
            <b-col cols="12" md="6" lg="4" class="text-left mb-2">
                <span><b>Base Legal</b></span>
                <br />
                <span class="pos-left">{{
                    licitacao.IdReferenciaLegalNavigation ? licitacao.IdReferenciaLegalNavigation.DeReferenciaLegal : '-'
                }}</span>
            </b-col>
            <b-col cols="12" md="6" lg="4" class="text-left mb-2">
                <span><b>Data de Publicação do {{licitacao.IdModalidade !== 38 ? 'Edital' : 'Aviso'}}</b></span>
                <br />
                <span class="pos-left">{{ licitacao.DtPublicacaoEdital ? formatData(licitacao.DtPublicacaoEdital) : '-'
                }}</span>
            </b-col>
            <b-col cols="12" md="6" lg="4" class="text-left mb-2">
                <span><b>Data da Sessão Inaugural</b></span>
                <br />
                <span class="pos-left">{{ licitacao.DtSessaoInaugural ? formatData(licitacao.DtSessaoInaugural) : '-'
                }}</span>
            </b-col>
            <b-col cols="12" md="6" lg="4" class="text-left mb-2">
                <span><b>Há previsão de pagamento antecipado?</b></span>
                <br />
                <span class="pos-left">{{ (licitacao.FlPagamentoAntecipado == "S") ? "Sim" : "Não" }}</span>
            </b-col>
            <b-col cols="12" md="6" lg="4" class="text-left mb-2">
                <span><b>Baixar arquivo texto do Edital (PDF) *</b></span>
                <div class="wrapper-icon">
                    <btn-download :fazerDownload="baixarAnexo" :texto="''" />
                </div>
            </b-col>
        </b-row>
    </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { UtilsTS } from '@/utilsts'

import BtnDownload from '@/components/shared/btn-download.vue'

import ldiService from '@/services/licitacoes/ldiService'
import { fieldsLicitacoes } from '@/types/licitacoes/ldi/fields-licitacoes'
import { Licitacao } from '@/types/licitacoes/ldi/licitacao'
import { TableField } from '@/types/table-field'

const CompProps = Vue.extend({
    name: 'DetalhesDadosGerais',
    components: { BtnDownload },
    props: {
        licitacao: {
            type: Object,
            required: true
        }
    }
})

@Component
export default class DetalhesDadosGerais extends mixins(UtilsTS, CompProps) {
    fields: TableField[] = fieldsLicitacoes
    licitacaoApi: Licitacao[] = []

    async baixarAnexo() {
        //console.log('baixar anexo licitacao')
        const arquivo = this.licitacao.ArquivoEdital
        const response = await ldiService.baixarAnexo(arquivo?.IdArquivo)
        this.download(`edital-${this.licitacao.NumeroAnoLicitacao}`, response.data)
    }
}
</script>

<style></style>